import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'
import { useFormatCurrency } from '@/shared/lib'

type Props = Pick<TRoomDetail, 'usingFee' | 'mgmtFee'>

export const ContractFee = ({ usingFee, mgmtFee }: Props) => {
  const t = useTranslations()

  const { formatCurrency } = useFormatCurrency()

  return (
    <div className="mb-7.5 space-y-1.5 px-6">
      <div className="typo-headline3 flex items-center gap-2">
        <p className="typo-title2 flex items-center gap-0.5 font-bold text-black">
          {formatCurrency(usingFee + mgmtFee, {
            unit: chunks => (
              <span className="typo-headline3 font-normal text-black">
                {chunks}
              </span>
            ),
          })}
        </p>
        <span className="font-light text-gray-200">/</span>
        <span className="font-semibold text-purple-500">
          {t('common.week_unit')}
        </span>
      </div>
      <dl className="flex gap-3">
        <div className="typo-body2 flex gap-1 font-normal">
          <dt className="shrink-0 text-gray-500">{t('common.rent')}</dt>
          <dd className="text-gray-900">{formatCurrency(usingFee)}</dd>
        </div>
        <div className="typo-body2 flex gap-1 font-normal">
          <dt className="shrink-0 text-gray-500">{t('common.utility_fee')}</dt>
          <dd className="text-gray-900">{formatCurrency(mgmtFee)}</dd>
        </div>
      </dl>
    </div>
  )
}
